<template>
    <data-table
        action-button-text="متن آماده جدید"
        action-button-icon="add"
        show-select
        remove-key="ticketTemplate"
        export-key="ticketTemplates"
        settings-key="ticketTemplates"
        @click:actionButton="router.push({path: '/settings/ticketTemplates/new' })"
        @getList="getList"
        @deleted="system.setSystemDefaults(true)"
        :rowClick="(row) => router.resolve({path: `/settings/ticketTemplates/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    >
    </data-table>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useSystemStore } from '@/stores/system';
import { useRouter } from 'vue-router';

defineOptions({
    title: "متن های از پیش آماده",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.ticket_canned_message;
    },
})
const api = useApi();
const router = useRouter();
const system = useSystemStore();
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 200,
    },
    {
        title: 'دپارتمان',
        key: 'department',
        value: (item) => system.departments.find(y => y.id == item.department_id).name,
        minWidth: 130,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس کلمه کلیدی', value: null },
    name: { type: 'text', label: 'عنوان', value: null },
    position_based: { type: 'divider', label: 'بر اساس شرایط نمایش', value: null },
    departments: { type: 'autocomplete', multiple: true, label: 'دپارتمان', items: system.departments, value: [] },
})
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.ticketTemplateList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.ticketTemplateList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
